import axios from "axios";
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
import { Action } from "api/action_types/sketch";
import { ActionType } from "api/action_types/sketch";
import { AxiosError } from "axios";
import { Action as AuthAction } from "api/action_types/authentication";
import { ActionType as AuthActionType } from "api/action_types/authentication";
import { Counter } from "api/types/sketch";
import { url_prefix } from "settings";
import { counter_url } from "../endpoint";

export const updateCounter = (counter: Counter, rotating?: boolean) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    dispatch({
      type: ActionType.SKETCH_UPDATING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    let url = `${url_prefix}${counter_url}/${counter.id ? counter.id : 0}/?uuid=${counter.uuid}&`;

    if (rotating) {
      url += "rotating=true&";
    }

    try {
      await axios.patch(url, counter, config);

      dispatch({
        type: ActionType.SKETCH_ACTION_SUCCESS
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SKETCH_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
